module.exports = __webpack_public_path__ + "1.5.0-unryo/img/gcp.d3b896b4.svg";